<template>
  <div class="subscription-cycle">
    <p id="subscription-cycle__title" class="subscription-cycle__title">{{ $t('billing.select_billing_cycle') }}</p>
    <zm-radio-group
      class="opc-card-radio subscription-cycle__radio-group"
      aria-labelledby="subscription-cycle__title"
      v-model="value"
      enter-select
      @change="handleRadioGroupChange"
    >
      <zm-tooltip v-for="item in options" :key="item.label" :disabled="!item.disabledTooltip">
        <template v-slot:content>
          <div v-html="item.disabledTooltip"></div>
        </template>
        <zm-radio data-testid="checkout-radio-36" :label="item.label" :disabled="!!item.disabled" :data-billing_cycle="item.billing_cycle">
          <slot>
            <p class="subscription-cycle__radio-group-title">
              <span>{{ item.cycle }}</span>
              <CycleCurrentBadge :value="item.__plan" />
              <save-count
                v-if="item.cyclePrice"
                class="subscription-cycle__radio-group-save"
                :disabled="!!item.disabled"
                :annual-price="item.cyclePrice.annualPrice"
                :monthly-price="item.cyclePrice.monthlyPrice"
              />
            </p>
            <div class="subscription-cycle__radio-group-subtitle">
              <p class="subscription-cycle__radio-group-price">{{ item.price }}</p>
              <p class="subscription-cycle__radio-group-unit">{{ item.unit }}<priceVATTip /></p>
            </div>
          </slot>
        </zm-radio>
      </zm-tooltip>
    </zm-radio-group>
  </div>
</template>
<script>
import saveCount from '@/components/save-count.vue';
import CycleCurrentBadge from '@/components/service/config-billing-cycle/cycle-current-badge.vue';

export default {
  name: 'SubscriptionCycle',
  components: { saveCount, CycleCurrentBadge },
  props: {
    value: String,
    options: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleRadioGroupChange(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/scss-utils.scss';

.subscription-cycle {
  margin-top: 24px;
  &__title {
    color: #00053d;
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;
    margin-bottom: 8px;
    @include darkTextColor;
  }

  &__radio-group {
    .zm-radio,
    .zm-radio__wrap {
      width: 100%;
    }

    .zm-radio__label--inner {
      width: 100%;
      min-height: 60px;
    }

    &-title {
      color: #00053d;
      font-size: 16px;
      font-weight: 600;
      line-height: 150%;
      display: flex;
      align-items: center;
      @include darkTextColor;
    }

    &-subtitle {
      word-break: break-word;
    }

    &-price {
      color: #00053d;
      font-size: 22px;
      font-weight: 700;
      line-height: 150%;
      @include darkTextColor;
    }

    &-unit {
      color: #515079;
      font-size: 12px;
      font-weight: 500;
      line-height: 150%;
      @include darkTextColor;
    }

    &-save {
      margin-left: 8px;
    }
  }
}
</style>
